// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Loyalty from "../../modules/Loyalty/Loyalty.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Customer from "../../modules/Customer/Customer.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as DeviceName from "../../modules/Device/DeviceName.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as SalesTable from "../../modules/Sale/SalesTable.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as SalesRoutes from "../Sales/SalesRoutes.res.js";
import * as ResourceList from "../../core/ResourceList.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as LabelTableCell from "../../modules/TableCell/LabelTableCell.res.js";
import * as ResourceListPage from "../../core/ResourceListPage.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["fragment CustomerDetailsLoyaltyHistoryActivityFragment on LoyaltyActivity   {\n__typename  \nid  \nkind  \npoints  \ncreatedAt  \nsalesReceipt  {\n__typename  \nid  \nname  \ntotalAmountIncludingTaxes  \nstaff  {\n__typename  \nid  \nname  \n}\n\nrefundReceipts  {\n__typename  \nid  \narchivedAt  \nname  \ncreatedAt  \n}\n\n}\n\nreward  {\n__typename  \nid  \nkind  \ndiscountUnit  \ndiscountValue  \ndiscountEvolutiveRate  {\n__typename  \neuros  \npoints  \n}\n\nofferedProductLabel  \n}\n\nvoucher  {\n__typename  \nid  \n}\n\ndevice  {\n__typename  \nid  \nname  \nslug  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.kind;
  let tmp;
  switch (value$1) {
    case "GAIN" :
      tmp = "GAIN";
      break;
    case "LOSS" :
      tmp = "LOSS";
      break;
    case "RESET" :
      tmp = "RESET";
      break;
    default:
      throw {
        RE_EXN_ID: "Not_found",
        Error: new Error()
      };
  }
  let value$2 = value.salesReceipt;
  let tmp$1;
  if (value$2 == null) {
    tmp$1 = undefined;
  } else {
    let value$3 = value$2.staff;
    let value$4 = value$2.refundReceipts;
    tmp$1 = {
      __typename: value$2.__typename,
      id: value$2.id,
      name: value$2.name,
      totalAmountIncludingTaxes: value$2.totalAmountIncludingTaxes,
      staff: {
        __typename: value$3.__typename,
        id: value$3.id,
        name: value$3.name
      },
      refundReceipts: value$4.map(value => {
        let value$1 = value.archivedAt;
        return {
          __typename: value.__typename,
          id: value.id,
          archivedAt: !(value$1 == null) ? Scalar.Datetime.parse(value$1) : undefined,
          name: value.name,
          createdAt: Scalar.Datetime.parse(value.createdAt)
        };
      })
    };
  }
  let value$5 = value.reward;
  let tmp$2;
  if (value$5 == null) {
    tmp$2 = undefined;
  } else {
    let value$6 = value$5.kind;
    let tmp$3;
    switch (value$6) {
      case "DISCOUNT" :
        tmp$3 = "DISCOUNT";
        break;
      case "OFFERED_PRODUCT" :
        tmp$3 = "OFFERED_PRODUCT";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    let value$7 = value$5.discountUnit;
    let tmp$4;
    if (value$7 == null) {
      tmp$4 = undefined;
    } else {
      let tmp$5;
      switch (value$7) {
        case "EUR" :
          tmp$5 = "EUR";
          break;
        case "PERCENTAGE" :
          tmp$5 = "PERCENTAGE";
          break;
        default:
          throw {
            RE_EXN_ID: "Not_found",
            Error: new Error()
          };
      }
      tmp$4 = tmp$5;
    }
    let value$8 = value$5.discountValue;
    let value$9 = value$5.discountEvolutiveRate;
    let value$10 = value$5.offeredProductLabel;
    tmp$2 = {
      __typename: value$5.__typename,
      id: value$5.id,
      kind: tmp$3,
      discountUnit: tmp$4,
      discountValue: !(value$8 == null) ? value$8 : undefined,
      discountEvolutiveRate: !(value$9 == null) ? ({
          __typename: value$9.__typename,
          euros: value$9.euros,
          points: value$9.points
        }) : undefined,
      offeredProductLabel: !(value$10 == null) ? value$10 : undefined
    };
  }
  let value$11 = value.voucher;
  let value$12 = value.device;
  return {
    __typename: value.__typename,
    id: value.id,
    kind: tmp,
    points: value.points,
    createdAt: Scalar.Datetime.parse(value.createdAt),
    salesReceipt: tmp$1,
    reward: tmp$2,
    voucher: !(value$11 == null) ? ({
        __typename: value$11.__typename,
        id: value$11.id
      }) : undefined,
    device: {
      __typename: value$12.__typename,
      id: value$12.id,
      name: value$12.name,
      slug: value$12.slug
    }
  };
}

function serialize(value) {
  let value$1 = value.device;
  let value$2 = value$1.slug;
  let value$3 = value$1.name;
  let value$4 = value$1.id;
  let value$5 = value$1.__typename;
  let device = {
    __typename: value$5,
    id: value$4,
    name: value$3,
    slug: value$2
  };
  let value$6 = value.voucher;
  let voucher;
  if (value$6 !== undefined) {
    let value$7 = value$6.id;
    let value$8 = value$6.__typename;
    voucher = {
      __typename: value$8,
      id: value$7
    };
  } else {
    voucher = null;
  }
  let value$9 = value.reward;
  let reward;
  if (value$9 !== undefined) {
    let value$10 = value$9.offeredProductLabel;
    let offeredProductLabel = value$10 !== undefined ? value$10 : null;
    let value$11 = value$9.discountEvolutiveRate;
    let discountEvolutiveRate;
    if (value$11 !== undefined) {
      let value$12 = value$11.points;
      let value$13 = value$11.euros;
      let value$14 = value$11.__typename;
      discountEvolutiveRate = {
        __typename: value$14,
        euros: value$13,
        points: value$12
      };
    } else {
      discountEvolutiveRate = null;
    }
    let value$15 = value$9.discountValue;
    let discountValue = value$15 !== undefined ? value$15 : null;
    let value$16 = value$9.discountUnit;
    let discountUnit = value$16 !== undefined ? (
        value$16 === "EUR" ? "EUR" : "PERCENTAGE"
      ) : null;
    let value$17 = value$9.kind;
    let kind = value$17 === "DISCOUNT" ? "DISCOUNT" : "OFFERED_PRODUCT";
    let value$18 = value$9.id;
    let value$19 = value$9.__typename;
    reward = {
      __typename: value$19,
      id: value$18,
      kind: kind,
      discountUnit: discountUnit,
      discountValue: discountValue,
      discountEvolutiveRate: discountEvolutiveRate,
      offeredProductLabel: offeredProductLabel
    };
  } else {
    reward = null;
  }
  let value$20 = value.salesReceipt;
  let salesReceipt;
  if (value$20 !== undefined) {
    let value$21 = value$20.refundReceipts;
    let refundReceipts = value$21.map(value => {
      let value$1 = value.createdAt;
      let value$2 = Scalar.Datetime.serialize(value$1);
      let value$3 = value.name;
      let value$4 = value.archivedAt;
      let archivedAt = value$4 !== undefined ? Scalar.Datetime.serialize(value$4) : null;
      let value$5 = value.id;
      let value$6 = value.__typename;
      return {
        __typename: value$6,
        id: value$5,
        archivedAt: archivedAt,
        name: value$3,
        createdAt: value$2
      };
    });
    let value$22 = value$20.staff;
    let value$23 = value$22.name;
    let value$24 = value$22.id;
    let value$25 = value$22.__typename;
    let staff = {
      __typename: value$25,
      id: value$24,
      name: value$23
    };
    let value$26 = value$20.totalAmountIncludingTaxes;
    let value$27 = value$20.name;
    let value$28 = value$20.id;
    let value$29 = value$20.__typename;
    salesReceipt = {
      __typename: value$29,
      id: value$28,
      name: value$27,
      totalAmountIncludingTaxes: value$26,
      staff: staff,
      refundReceipts: refundReceipts
    };
  } else {
    salesReceipt = null;
  }
  let value$30 = value.createdAt;
  let value$31 = Scalar.Datetime.serialize(value$30);
  let value$32 = value.points;
  let value$33 = value.kind;
  let kind$1 = value$33 === "GAIN" ? "GAIN" : (
      value$33 === "LOSS" ? "LOSS" : "RESET"
    );
  let value$34 = value.id;
  let value$35 = value.__typename;
  return {
    __typename: value$35,
    id: value$34,
    kind: kind$1,
    points: value$32,
    createdAt: value$31,
    salesReceipt: salesReceipt,
    reward: reward,
    voucher: voucher,
    device: device
  };
}

function verifyArgsAndParse(_CustomerDetailsLoyaltyHistoryActivityFragment, value) {
  return parse(value);
}

function verifyName(_fragmentName) {
  
}

let CustomerDetailsLoyaltyHistoryActivityFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

let Raw$1 = {};

let query$1 = Client.gql([
  "query CustomerDetailsLoyaltyHistoryQuery($customerId: ID!, $before: String, $after: String, $first: Int, $last: Int)  {\ncustomer(id: $customerId)  {\n__typename  \nid  \nfirstName  \nlastName  \ncompanyName  \nloyaltyActivities(before: $before, after: $after, first: $first, last: $last)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n...CustomerDetailsLoyaltyHistoryActivityFragment   \n}\n\n}\n\n}\n\n}\n\n}\n",
  ""
], query);

function parse$1(value) {
  let value$1 = value.customer;
  let value$2 = value$1.firstName;
  let value$3 = value$1.lastName;
  let value$4 = value$1.companyName;
  let value$5 = value$1.loyaltyActivities;
  let value$6 = value$5.pageInfo;
  let value$7 = value$6.startCursor;
  let value$8 = value$6.endCursor;
  let value$9 = value$5.edges;
  return {
    customer: {
      __typename: value$1.__typename,
      id: value$1.id,
      firstName: !(value$2 == null) ? value$2 : undefined,
      lastName: !(value$3 == null) ? value$3 : undefined,
      companyName: !(value$4 == null) ? value$4 : undefined,
      loyaltyActivities: {
        __typename: value$5.__typename,
        pageInfo: {
          __typename: value$6.__typename,
          startCursor: !(value$7 == null) ? value$7 : undefined,
          endCursor: !(value$8 == null) ? value$8 : undefined
        },
        totalCount: value$5.totalCount,
        edges: value$9.map(value => {
          let value$1 = value.node;
          return {
            __typename: value.__typename,
            node: parse(value$1)
          };
        })
      }
    }
  };
}

function serialize$1(value) {
  let value$1 = value.customer;
  let value$2 = value$1.loyaltyActivities;
  let value$3 = value$2.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let node = serialize(value$1);
    let value$2 = value.__typename;
    return {
      __typename: value$2,
      node: node
    };
  });
  let value$4 = value$2.totalCount;
  let value$5 = value$2.pageInfo;
  let value$6 = value$5.endCursor;
  let endCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$5.startCursor;
  let startCursor = value$7 !== undefined ? value$7 : null;
  let value$8 = value$5.__typename;
  let pageInfo = {
    __typename: value$8,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$9 = value$2.__typename;
  let loyaltyActivities = {
    __typename: value$9,
    pageInfo: pageInfo,
    totalCount: value$4,
    edges: edges
  };
  let value$10 = value$1.companyName;
  let companyName = value$10 !== undefined ? value$10 : null;
  let value$11 = value$1.lastName;
  let lastName = value$11 !== undefined ? value$11 : null;
  let value$12 = value$1.firstName;
  let firstName = value$12 !== undefined ? value$12 : null;
  let value$13 = value$1.id;
  let value$14 = value$1.__typename;
  let customer = {
    __typename: value$14,
    id: value$13,
    firstName: firstName,
    lastName: lastName,
    companyName: companyName,
    loyaltyActivities: loyaltyActivities
  };
  return {
    customer: customer
  };
}

function serializeVariables(inp) {
  let a = inp.before;
  let a$1 = inp.after;
  let a$2 = inp.first;
  let a$3 = inp.last;
  return {
    customerId: inp.customerId,
    before: a !== undefined ? a : undefined,
    after: a$1 !== undefined ? a$1 : undefined,
    first: a$2 !== undefined ? a$2 : undefined,
    last: a$3 !== undefined ? a$3 : undefined
  };
}

function makeVariables(customerId, before, after, first, last, param) {
  return {
    customerId: customerId,
    before: before,
    after: after,
    first: first,
    last: last
  };
}

let CustomerDetailsLoyaltyHistoryQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables
});

let use = include.use;

let CustomerDetailsLoyaltyHistoryQuery_refetchQueryDescription = include.refetchQueryDescription;

let CustomerDetailsLoyaltyHistoryQuery_useLazy = include.useLazy;

let CustomerDetailsLoyaltyHistoryQuery_useLazyWithVariables = include.useLazyWithVariables;

let CustomerDetailsLoyaltyHistoryQuery = {
  CustomerDetailsLoyaltyHistoryQuery_inner: CustomerDetailsLoyaltyHistoryQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: CustomerDetailsLoyaltyHistoryQuery_refetchQueryDescription,
  use: use,
  useLazy: CustomerDetailsLoyaltyHistoryQuery_useLazy,
  useLazyWithVariables: CustomerDetailsLoyaltyHistoryQuery_useLazyWithVariables
};

function keyExtractor(param) {
  return param.id;
}

function groupBySalesReceipt(rows) {
  let groupedSalesReceiptIds = new Set();
  return rows.flatMap(row => {
    let match = row.salesReceipt;
    if (match === undefined) {
      return [row];
    }
    let id = match.id;
    if (groupedSalesReceiptIds.has(id)) {
      return [];
    }
    groupedSalesReceiptIds.add(id);
    let group = rows.filter(param => Stdlib_Option.mapOr(param.salesReceipt, false, salesReceipt => salesReceipt.id === id));
    let groupRewardLabel = Stdlib_Array.findMap(group, param => param.rewardLabel);
    return group.map(row => {
      let match = row.kind;
      let match$1 = row.rewardLabel;
      switch (match) {
        case "Gain" :
        case "Loss" :
          return row;
        case "Reset" :
          if (match$1 !== undefined) {
            return row;
          }
          let newrecord = {...row};
          newrecord.rewardLabel = groupRewardLabel;
          return newrecord;
      }
    }).toSorted((current, next) => {
      let match = current.kind;
      let match$1 = next.kind;
      switch (match) {
        case "Gain" :
        case "Loss" :
          break;
        case "Reset" :
          switch (match$1) {
            case "Gain" :
            case "Loss" :
              return -1;
            case "Reset" :
              return 0;
          }
      }
      switch (match$1) {
        case "Gain" :
        case "Loss" :
          return 0;
        case "Reset" :
          return 1;
      }
    });
  });
}

function fromFragment(activity) {
  let kind = Loyalty.LoyaltyActivityKind.fromRaw(activity.kind);
  let device = DeviceName.decode(activity.device.slug, activity.device.name);
  let reason = Loyalty.LoyaltyActivityReason.make(kind, activity.points, Stdlib_Option.isSome(activity.salesReceipt), Stdlib_Option.isSome(activity.reward) || Stdlib_Option.isSome(activity.voucher));
  let match;
  match = typeof reason !== "object" && reason === "Return" ? [
      "Loss",
      -activity.points | 0
    ] : [
      kind,
      activity.points
    ];
  return {
    id: activity.id,
    kind: match[0],
    reason: reason,
    points: match[1],
    salesReceipt: Stdlib_Option.map(activity.salesReceipt, receipt => ({
      id: receipt.id,
      name: receipt.name,
      totalAmountIncludingTaxes: receipt.totalAmountIncludingTaxes,
      staffName: receipt.staff.name,
      refundReceipts: Stdlib_Array.filterMap(receipt.refundReceipts, param => {
        if (param.archivedAt !== undefined) {
          return;
        } else {
          return {
            label: param.name,
            date: param.createdAt
          };
        }
      })
    })),
    rewardLabel: Stdlib_Option.map(Stdlib_Option.flatMap(activity.reward, reward => Loyalty.makeReward(reward.kind, Stdlib_Option.map(reward.discountEvolutiveRate, param => ({
      euros: param.euros,
      points: param.points
    })), reward.discountUnit, reward.discountValue, reward.offeredProductLabel)), Loyalty.formateRewardTitle),
    deviceName: DeviceName.format(device),
    createdAt: activity.createdAt
  };
}

let LoyaltyHistoryTableRow = {
  keyExtractor: keyExtractor,
  groupBySalesReceipt: groupBySalesReceipt,
  fromFragment: fromFragment
};

let tableColumns = [
  {
    key: "points",
    name: I18n.t("Points"),
    layout: {
      width: "fitContent",
      alignX: "flexEnd"
    },
    render: param => {
      let match = param.data;
      let kind = match.kind;
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: Loyalty.formateActivityPoints(kind, match.points),
        labelVariation: {
          NAME: "custom",
          VAL: Loyalty.LoyaltyActivityKind.toColor(kind)
        },
        align: "end",
        inPrimaryColumn: true
      });
    }
  },
  {
    key: "kind",
    name: I18n.t("Type"),
    layout: {
      minWidth: "fitContent",
      margin: "medium"
    },
    render: param => {
      let match = param.data;
      let rewardLabel = match.rewardLabel;
      let salesReceipt = match.salesReceipt;
      let reason = match.reason;
      let label;
      if (typeof reason !== "object") {
        switch (reason) {
          case "RewardUsed" :
          case "RewardReset" :
            label = rewardLabel !== undefined ? rewardLabel : Loyalty.LoyaltyActivityReason.toLabel(reason);
            break;
          default:
            label = Loyalty.LoyaltyActivityReason.toLabel(reason);
        }
      } else {
        label = Loyalty.LoyaltyActivityReason.toLabel(reason);
      }
      let tmp;
      if (salesReceipt !== undefined) {
        let refundReceipts = salesReceipt.refundReceipts;
        tmp = refundReceipts.length !== 0 ? JsxRuntime.jsx(SalesTable.SalesListPageSecondaryStatusBadge.make, {
            value: "Refunded",
            details: refundReceipts,
            hideLabel: true
          }) : null;
      } else {
        tmp = null;
      }
      return JsxRuntime.jsxs(Inline.make, {
        children: [
          JsxRuntime.jsx(Loyalty.LoyaltyActivityKind.Badge.make, {
            kind: match.kind,
            label: label
          }),
          tmp
        ],
        space: "xsmall",
        grow: false
      });
    }
  },
  {
    key: "details",
    name: I18n.t("Details"),
    layout: {
      minWidth: "fitContent",
      width: {
        NAME: "fr",
        VAL: 1.2
      },
      margin: "medium"
    },
    render: param => {
      let salesReceipt = param.data.salesReceipt;
      if (salesReceipt === undefined) {
        return JsxRuntime.jsx(Placeholder.NA.make, {});
      }
      let sublabel = I18n.currencyFormat(undefined, "EUR", undefined, undefined, salesReceipt.totalAmountIncludingTaxes) + ` ` + I18n.t("VAT incl.");
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: salesReceipt.name,
        labelBold: true,
        labelStartElement: SalesTable.svgFromSaleType("SalesReceipt"),
        sublabel: sublabel,
        href: SalesRoutes.showRoute("SalesReceipt", salesReceipt.id)
      });
    }
  },
  {
    key: "date",
    name: I18n.t("Date"),
    layout: {
      minWidth: "fitContent",
      margin: "medium"
    },
    render: param => {
      let createdAt = param.data.createdAt;
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: DateHelpers.formateToShortDate(createdAt),
        sublabel: DateHelpers.formateToShortTime(undefined, createdAt)
      });
    }
  },
  {
    key: "source",
    name: I18n.t("Source"),
    layout: {
      minWidth: "fitContent"
    },
    render: param => {
      let match = param.data;
      return JsxRuntime.jsx(LabelTableCell.make, {
        label: match.deviceName,
        sublabel: Stdlib_Option.map(match.salesReceipt, param => param.staffName)
      });
    }
  },
  {
    key: "actions",
    layout: {
      minWidth: {
        NAME: "px",
        VAL: 48
      },
      width: {
        NAME: "px",
        VAL: 48
      },
      alignX: "flexEnd",
      sticky: true
    },
    render: param => {
      let salesReceipt = param.data.salesReceipt;
      return JsxRuntime.jsx(Tooltip.make, {
        children: JsxRuntime.jsx(Offset.make, {
          children: JsxRuntime.jsx(MenuActions.make, {
            children: salesReceipt !== undefined ? JsxRuntime.jsx(MenuActions.Item.make, {
                title: I18n.t("See sales receipt"),
                href: SalesRoutes.showRoute("SalesReceipt", salesReceipt.id),
                icon: "variant_see"
              }) : null,
            trigger: {
              TAG: "Compact",
              icon: "more_v2",
              variant: "subtle",
              size: "small",
              bold: true
            },
            disabled: Stdlib_Option.isNone(salesReceipt)
          }),
          right: -13,
          width: 48,
          height: 32
        }),
        arrowed: false,
        placement: "top",
        content: JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("No action available")
        }),
        disabled: Stdlib_Option.isSome(salesReceipt),
        closeDelay: 0
      });
    }
  }
];

let unitJsonCodec = JsonCodec.object1(() => {}, param => ({
  TAG: "Ok",
  _0: undefined
}), JsonCodec.optional(JsonCodec.field("none", JsonCodec.bool)));

function queryVariables(customerId, param) {
  let match = param.connectionArguments;
  return {
    customerId: customerId,
    before: match.before,
    after: match.after,
    first: match.first,
    last: match.last
  };
}

let tableLoadingOperations = [query$1];

function useQueryAsyncResultFn(variables) {
  return ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, variables));
}

function tableRowsFromQueryResult(param) {
  return groupBySalesReceipt(param.customer.loyaltyActivities.edges.map(param => fromFragment(param.node)));
}

function CustomerDetailsLoyaltyHistoryPage(props) {
  let __useQueryAsyncResult = props.useQueryAsyncResult;
  let useQueryAsyncResult = __useQueryAsyncResult !== undefined ? __useQueryAsyncResult : useQueryAsyncResultFn;
  let match = Navigation.useGoBack();
  let initialState = ResourceList.initialState(50, undefined, undefined, undefined, undefined);
  let match$1 = ResourceList.use(initialState, unitJsonCodec, unitJsonCodec, undefined, undefined);
  let dispatch = match$1[1];
  let state = match$1[0];
  let queryAsyncResult = useQueryAsyncResult(queryVariables(props.id, state));
  let title;
  let exit = 0;
  let firstName;
  let lastName;
  let companyName;
  if (typeof queryAsyncResult !== "object") {
    title = I18n.t("Loyalty history");
  } else if (queryAsyncResult.TAG === "Reloading") {
    let match$2 = queryAsyncResult._0;
    if (match$2.TAG === "Ok") {
      let match$3 = match$2._0.customer;
      firstName = match$3.firstName;
      lastName = match$3.lastName;
      companyName = match$3.companyName;
      exit = 1;
    } else {
      title = I18n.t("Loyalty history");
    }
  } else {
    let match$4 = queryAsyncResult._0;
    if (match$4.TAG === "Ok") {
      let match$5 = match$4._0.customer;
      firstName = match$5.firstName;
      lastName = match$5.lastName;
      companyName = match$5.companyName;
      exit = 1;
    } else {
      title = I18n.t("Loyalty history");
    }
  }
  if (exit === 1) {
    let name = Customer.makeName(firstName, lastName, companyName);
    title = name !== undefined ? I18n.t("Loyalty history") + ` · ` + name : I18n.t("Loyalty history");
  }
  let tableData = AsyncResult.mapError(AsyncResult.mapOk(queryAsyncResult, tableRowsFromQueryResult), param => {});
  let paginationTotalCount;
  if (typeof queryAsyncResult !== "object") {
    paginationTotalCount = 0;
  } else if (queryAsyncResult.TAG === "Reloading") {
    let match$6 = queryAsyncResult._0;
    paginationTotalCount = match$6.TAG === "Ok" ? match$6._0.customer.loyaltyActivities.totalCount : 0;
  } else {
    let match$7 = queryAsyncResult._0;
    paginationTotalCount = match$7.TAG === "Ok" ? match$7._0.customer.loyaltyActivities.totalCount : 0;
  }
  let paginationTotalPages = ResourceList.totalPages(paginationTotalCount, ResourceList.defaultEdgesPerPage);
  let paginationLoading = AsyncResult.isReloading(queryAsyncResult);
  let paginationLastDirection = state.currentPage > state.previousPage ? "Forward" : "Backward";
  let onRequestPaginate = React.useCallback(action => {
    let startCursor;
    let endCursor;
    let totalCount;
    if (typeof queryAsyncResult !== "object") {
      return;
    }
    if (queryAsyncResult.TAG === "Reloading") {
      let match = queryAsyncResult._0;
      if (match.TAG !== "Ok") {
        return;
      }
      let match$1 = match._0.customer.loyaltyActivities;
      let match$2 = match$1.pageInfo;
      startCursor = match$2.startCursor;
      endCursor = match$2.endCursor;
      totalCount = match$1.totalCount;
    } else {
      let match$3 = queryAsyncResult._0;
      if (match$3.TAG !== "Ok") {
        return;
      }
      let match$4 = match$3._0.customer.loyaltyActivities;
      let match$5 = match$4.pageInfo;
      startCursor = match$5.startCursor;
      endCursor = match$5.endCursor;
      totalCount = match$4.totalCount;
    }
    let totalPages = ResourceList.totalPages(totalCount, ResourceList.defaultEdgesPerPage);
    let nextPage = ResourceList.nextPage(state, action, totalPages);
    let cursors = [
      startCursor,
      endCursor
    ];
    if (nextPage !== undefined) {
      return dispatch({
        TAG: "Navigated",
        nextPage: nextPage,
        totalCount: totalCount,
        cursors: cursors
      });
    }
  }, [
    state.currentPage,
    queryAsyncResult
  ]);
  let tableLoadingInteraction = ResourceList.useLoadingInteraction(state, undefined);
  return JsxRuntime.jsx(ResourceListPage.make, {
    title: title,
    tableData: tableData,
    tableColumns: tableColumns,
    tableKeyExtractor: keyExtractor,
    tableEmptyState: JsxRuntime.jsx(Placeholder.make, {
      status: "NoDataAvailable"
    }),
    paginationCurrentPage: state.currentPage,
    paginationTotalCount: paginationTotalCount,
    paginationTotalPages: paginationTotalPages,
    paginationLoading: paginationLoading,
    paginationLastDirection: paginationLastDirection,
    tableLoadingOperations: tableLoadingOperations,
    tableLoadingInteraction: tableLoadingInteraction,
    onRequestPaginate: onRequestPaginate,
    onRequestGoBack: match[0] ? match[1] : undefined
  });
}

let make = CustomerDetailsLoyaltyHistoryPage;

export {
  CustomerDetailsLoyaltyHistoryActivityFragment,
  CustomerDetailsLoyaltyHistoryQuery,
  LoyaltyHistoryTableRow,
  tableColumns,
  unitJsonCodec,
  queryVariables,
  tableLoadingOperations,
  useQueryAsyncResultFn,
  tableRowsFromQueryResult,
  make,
}
/* query Not a pure module */
